<template>
  <div class="create-team">
    <div class="btn-wrapper mb-10 move-right">
      <button @click="$router.go(-1)" class="btn-back">
        <span>Back</span>
      </button>
    </div>
    <el-form
      :model="changePasswordForm"
      ref="changePasswordForm"
      :rules="rules"
      class="white-bg form"
      label-position="left"
      label-width="220px"
      v-loading="loading"
    >
      <h3 class="text-gray bold mt-0 mb-40">Change Password</h3>

      <el-form-item prop="current_password" label="Enter Old Password">
        <el-input
          placeholder="Enter Old Password"
          v-model="changePasswordForm.current_password"
          type="password"
        ></el-input>
      </el-form-item>
      <el-form-item prop="new_password" label="Enter New Password">
        <el-input
          placeholder="Enter New Password"
          v-model="changePasswordForm.new_password"
          type="password"
        ></el-input>
      </el-form-item>
      <el-form-item prop="re_new_password" label="Confirm New Password">
        <el-input
          placeholder="Confirm New Password"
          v-model="changePasswordForm.re_new_password"
          type="password"
        ></el-input>
      </el-form-item>
      <div class="input-group">
        <div class="btn-wrapper mt-20">
          <el-button
            class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15 btn-big"
            @click.prevent="changePassword()"
            :loading="loading"
            >Change Password</el-button
          >
          <button
            class="btn blue-border btn-full-radius inline-flex flex-v-end mr-15 btn-big"
            @click.prevent="$router.go(-1)"
          >
            Cancel
          </button>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      changePasswordForm: {
        current_password: "",
        new_password: "",
        re_new_password: "",
      },
      rules: {
        current_password: [
          {
            type: "string",
            required: true,
            message: "Kindly input your old password",
            trigger: "blur",
          },
        ],
        new_password: [
          {
            type: "string",
            required: true,
            message: "Kindly input your new password",
            trigger: "blur",
          },
        ],
        re_new_password: [
          {
            type: "string",
            required: true,
            message: "Kindly input your new password again",
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    changePassword() {
      this.$refs["changePasswordForm"].validate(valid => {
        if (!valid) {
          return false;
        }

        this.loading = true;
        const params = {
          current_password: this.changePasswordForm.current_password,
          new_password: this.changePasswordForm.new_password,
        };

        this.$store
          .dispatch("auth/changePassword", params)
          .then(response => {
            this.loading = false;
            this.$refs["changePasswordForm"].resetFields();
            this.$router.go(-1);
            this.$notification.success(response.message);
          })
          .catch(error => {
            this.loading = false;
            this.$notification.error(error.message, { offset: 100 });
          });
      });
    },
  },
};
</script>
